var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27782 5.12918C2.32183 5.11685 1.40932 5.52788 0.785061 6.25201C0.160806 6.97615 -0.111292 7.93926 0.0417587 8.883L13.7788 92.2762C14.1321 94.3827 15.9469 95.9315 18.0828 95.9492H83.9851C85.5882 95.9698 86.9648 94.8135 87.2212 93.2309L100.958 8.89918C101.111 7.95545 100.839 6.99233 100.215 6.26819C99.5907 5.54406 98.6782 5.13303 97.7222 5.14536L3.27782 5.12918ZM61.1224 65.4008H40.088L34.3925 35.6452H66.2192L61.1224 65.4008Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5066 35.603H66.1604L61.0677 65.3348H40.0501L15.2332 94.7918C16.0197 95.472 17.0226 95.8502 18.0624 95.8589H83.9284C85.5302 95.8795 86.9057 94.7241 87.1618 93.1428L96.5066 35.603Z",
    fill: "url(#paint0_linear_30_426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_426",
    x1: 103.523,
    y1: 43.9292,
    x2: 68.4683,
    y2: 93.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.6bba0b4fbd7a6e01fb1f083c7ea46a46.svg";
export { ForwardRef as ReactComponent };